module.exports = __webpack_public_path__ + "static/media/india.527174fd.svg";